import CandidatesApi from '../../api/CandidatesApi'
import EnrollmentDocumentsApi from '../../api/EnrollmentDocumentsApi'
import { ApiException } from '../../api/exceptions'
import { SET_UNENROLLED_STUDENT_INFO_LOADING, SET_UNENROLLED_STUDENT_INFO_ERROR, SET_UNENROLLED_STUDENT_INFO, 
  SET_UNENROLLED_STUDENT_INFO_RESET } from '../types'
    
const candidatesApi = new CandidatesApi();
const enrollmentDocumentsApi = new EnrollmentDocumentsApi();

export const getUnenrolledStudent = (controlNumber) => {
  return async (dispatch) => {

    dispatch(setLoading())

    try {
      const studentInfo = await candidatesApi.get(controlNumber)
      await candidatesApi.block(controlNumber)
      const documentsInfo = await enrollmentDocumentsApi.list(controlNumber);

      const payload = {
        info: studentInfo,
        documents: documentsInfo
      }

      dispatch(setUnenrolledStudent(payload))

    } catch (error) {
      const message = (error instanceof ApiException) ? error.message : 'Hubo un error al obtener la información del aceptado. Intente más tarde.';
      dispatch(setError({ message }))
    }
  }
}

export const blockUnenrolledStudent = (controlNumber) => {
  return async () => await candidatesApi.block(controlNumber);
}

export const resetUnenrolledStudent = () => {
  return dispatch => dispatch(reset())
}

/** action creators */
const setLoading = () => ({type: SET_UNENROLLED_STUDENT_INFO_LOADING})

const setUnenrolledStudent = payload => ({type: SET_UNENROLLED_STUDENT_INFO, payload })

const reset = () => ({type: SET_UNENROLLED_STUDENT_INFO_RESET})

const setError = payload => ({type: SET_UNENROLLED_STUDENT_INFO_ERROR, payload })